import React, { forwardRef } from 'react';
import { Modal } from '@orijinworks/frontend-commons';
import { Typography, Box, withStyles } from '@material-ui/core';
import { Badge } from '../MaterialUIComponents';
import styles from './feed-members-and-receipts-info-modal.styles';

const FeedMembersAndReceiptsInfoModal = forwardRef(
  ({
    classes,
    headingIcon,
    heading,
    badgeLabel,
    members,
    children,
    ...modalProps
  }, ref) => {
    const customHeading = (
      <Box className={classes.headingWithBadge}>
        <Typography component="span" className={classes.headingText}>
          {heading || ''}
        </Typography>
        <Badge
          badgeContent={badgeLabel ?? ''}
          className={classes.badge}
        />
      </Box>
    );

    return (
      <Modal
        ref={ref}
        {...modalProps}
        heading={customHeading}
        Icon={headingIcon}
        showCrossIcon={true}
      >

        {members && Array.isArray(members) && members.length > 0 && (
          <Box className={classes.bodyInfoContainer}>
            <Typography className={classes.bodyInfoText} variant="body1">
              {members.join(', ')}
            </Typography>
          </Box>
        )}

        {children}
      </Modal>
    );
  }
);

FeedMembersAndReceiptsInfoModal.displayName = 'FeedMembersAndReceiptsInfoModal';

export default withStyles(styles)(FeedMembersAndReceiptsInfoModal);
